import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@/context/I18nProvider';
import { TranslationKeys } from '@/locales';
import Image from 'next/image';
type NestedKeyOf<T> = T extends object ? { [K in keyof T]: K extends string ? T[K] extends object ? `${K}.${NestedKeyOf<T[K]>}` : K : never }[keyof T] : never;
type TranslationKey = NestedKeyOf<TranslationKeys>;
type TestimonialCardProps = {
  avatar: string;
  quoteKey: TranslationKey;
  nameKey: TranslationKey;
  roleKey: TranslationKey;
  companyKey: TranslationKey;
  position: number; // -1 = left, 0 = center, 1 = right
};
export const TestimonialCard = t0 => {
  const $ = _c(41);
  const {
    avatar,
    quoteKey,
    nameKey,
    roleKey,
    companyKey,
    position
  } = t0;
  const {
    t
  } = useI18n();
  const isCenter = position === 0;
  const isLeft = position === -1;
  const isRight = position === 1;
  const isVisible = isCenter || isLeft || isRight;
  const t1 = isCenter ? "translateX(0%) scale(1)" : isLeft ? "translateX(-85%) scale(0.88)" : isRight ? "translateX(85%) scale(0.88)" : "translateX(170%) scale(0.8)";
  const t2 = isCenter ? 1 : isLeft || isRight ? 0.45 : 0;
  const t3 = isCenter ? 20 : 10;
  const t4 = isCenter ? "auto" : "none";
  const t5 = isVisible ? "visible" : "hidden";
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = {
      transform: t1,
      opacity: t2,
      zIndex: t3,
      transition: "all 4s cubic-bezier(0.16, 1, 0.3, 1)",
      pointerEvents: t4,
      visibility: t5
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== quoteKey || $[7] !== t) {
    t7 = t(quoteKey);
    $[6] = quoteKey;
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <blockquote className="text-gray-700 text-lg leading-relaxed whitespace-pre-line break-words min-w-0">“{t7}”</blockquote>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== nameKey || $[12] !== t) {
    t9 = t(nameKey);
    $[11] = nameKey;
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== avatar || $[15] !== t9) {
    t10 = <Image src={avatar} alt={t9} width={56} height={56} className="size-14 rounded-full object-cover shrink-0" />;
    $[14] = avatar;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== nameKey || $[18] !== t) {
    t11 = t(nameKey);
    $[17] = nameKey;
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <h3 className="font-bold text-base text-gray-900">{t11}</h3>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== roleKey || $[23] !== t) {
    t13 = t(roleKey);
    $[22] = roleKey;
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== companyKey || $[26] !== t) {
    t14 = t(companyKey);
    $[25] = companyKey;
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <p className="text-sm text-gray-500">{t13} · {t14}</p>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t12 || $[32] !== t15) {
    t16 = <div className="min-w-0">{t12}{t15}</div>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t16) {
    t17 = <div className="flex items-center gap-3 min-w-0">{t10}{t16}</div>;
    $[34] = t10;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t6 || $[39] !== t8) {
    t18 = <div className="absolute inset-x-0 top-0 bg-white rounded-2xl p-8 shadow-2xl flex flex-col gap-8 overflow-hidden" style={t6}>{t8}{t17}</div>;
    $[37] = t17;
    $[38] = t6;
    $[39] = t8;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};